exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-nav[data-v-3504316a]{background:#fff;margin-bottom:15px}.content-nav a[data-v-3504316a],.content-nav span[data-v-3504316a]{float:left;width:16.66666666%;text-align:center;line-height:60px;border-bottom:4px solid #fefefe;font-size:16px;color:#666;padding-top:4px;cursor:pointer}.content-nav a[data-v-3504316a]:hover,.content-nav span[data-v-3504316a]:hover{color:#e03a3c}.content-nav a.grey[data-v-3504316a],.content-nav span.grey[data-v-3504316a]{color:#ccc;cursor:default}.content-nav a.nuxt-link-active[data-v-3504316a],.content-nav span.nuxt-link-active[data-v-3504316a]{border-color:#e03a3c}", ""]);

// exports
